import React from "react";
import Table from "../../components/table";
import Styles from "./styles.module.scss";
import FormHead from "../../components/headings/FromHead";
import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import AddUser from "../../modal/adduser/index";


function Users(props: any) {

  const userLoginId = localStorage.getItem('loginId')
  const [addUser, setAddUser] = useState<boolean>(false);
  const [userId, setUserId] = useState<string>('')

  const addNewUser = (data: any) => {
    setUserId('')
    let body = {
      "customerId": props.customerId,
      "userLoginId":userLoginId,
      "userMetadata":{
          "firstName":data.firstName,
          "lastName":data.lastName,
          "designation":data.designation,
          "email":data.email,
          "phone":data.phone && data.phone.toString(),
      }
    }    
    props.addNewUser(body)
    setAddUser(false)
  }

  return (
    <div >
      <div className="form-group">
        <figure className={Styles.uploadPicWrap}>
          {props.defImage ? <img src={props.defImage} /> :
          <span className={Styles.noPicWrap}>{props.companyName && props.companyName[0]}{props.companyName && props.companyName[1]}</span>}   
        </figure>
      </div>
      <div className={Styles.subHeadWrap}>
        <FormHead>Users</FormHead>
        <a
          className={Styles.addWorkHistory}
          onClick={() => setAddUser(true)}
        >
          <Icon icon="fluent:add-16-filled" />
          Add new user
        </a>
      </div>
      <div className="tableStyle no-min-height no-top-padd">
        <div className={Styles.usersListTable}>
          <Table data={props.usersList} type={'usersTable'} addNewUser={props.addNewUser} editUserStatus={props.editUserStatus} getUser={props.getUser} defaultValues={props.defaultValues} customerId={props.customerId}/>
        </div>
      </div>
      {addUser && <AddUser onClose={() => setAddUser(false)} clickHandler={addNewUser} />}
    </div>
  );
}

export default Users;
